<template>
  <div
    class="fehler-melden"
    @click="show = !show"
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
    >
      <v-btn
        flat
        slot="activator"
				icon
      >
        <v-icon >input</v-icon>
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Anfrage (Beta Test)</span>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <p>Hier eintippen:</p>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container grid-list-md>
              <v-layout wrap="">
                <v-flex xs12>
                  <v-textarea
                    v-model="text"
                    label="Ihr Anliegen?"
                    auto-grow
                    required
                    :rules="textRules"
                    counter="800"
                  ></v-textarea>
                </v-flex>
								 <v-flex xs12>
                  <v-text-field
                    v-model="name"
                    label="Ihr Name"
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12>
                  <v-text-field
                    v-model="telefon"
                    label="Ihre Telefonnummer"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="email"
                    label="Ihre Email"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>* Um Missbrauch vorzubeugen speichern wir technische Informationen zu Ihrem Gerät.</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=""
            flat
            @click.native="dialog = false"
          >Abbrechen</v-btn>
          <v-btn
            color="primary"
            @click="anfragesenden()"
            :loading="loading"
          >Absenden</v-btn>
        </v-card-actions>

        <v-card-text>
          {{ this.landing }} in {{ this.stadt }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['stadt', 'landing'],
  data () {
    return {
      show: false,
      dialog: false,
      text: '',
      block: false,
      loading: false,
      email: '',
      telefon: '',
      name: '',
      valid: false,
      textRules: [
        v => !!v || 'Bitte Text angeben',
        v =>
          (v && v.length <= 800) ||
          'Bitte nicht mehr als 800 Buchstaben verwenden.'
      ]
    }
  },
  methods: {
    anfragesenden () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const daten = {
          landing: this.landing,
          stadt: this.stadt,
          id: this.id,
          name: this.name,
          telefon: this.telefon,
          text: this.text,
          email: this.email
        }

        axios
          .post('/api/v1/anfragesenden', daten)
          .then(resp => {
            // console.log(resp)

            this.text = ''

            this.$store.dispatch('responseMessage', {
              type: 'success',
              modal: 'true',
              title: 'Anfrage abgesendet! ',
              text: 'Vielen Dank, wir werden Ihre Anfrage schnellstmöglichst weiterleiten.'
            })
            this.dialog = false
            // this.block = true
          })
          .catch(resp => {
            // console.log('error: ')
            //   console.log(resp);
          })

        this.loading = false
      }
    }
  },
  computed: {}
}
</script>
<style>
</style>